import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';

const FolioList = lazy(() => import('../Pages/FolioList'));
const FolioAdd = lazy(() => import('../Pages/FolioAdd'));
const FolioView = lazy(() => import('../Pages/FolioView'));
const FolioAgingReport = lazy(() => import('../Pages/FolioAgingReport'));

const Loading = () => (
    <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>
);

function FolioRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                exact
                path="/:lng/business/folios"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <FolioList history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/business/folios/add"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <FolioAdd history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/business/folios/edit/:slack"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <FolioAdd history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path={["/:lng/business/folios/reports/aging", "/:lng/business/folios/aging"]}
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <FolioAgingReport history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/business/folios/view/:slack"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <FolioView history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
        </Switch>
    );
}

export default FolioRoute;

